/// <reference path="../../app.typings.d.ts" />
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var Services;
    (function (Services) {
        var ApplicationApiService = /** @class */ (function (_super) {
            __extends(ApplicationApiService, _super);
            function ApplicationApiService($q, $sce, authenticationService, httpService, appSettings, organizationList) {
                var _this = _super.call(this, httpService) || this;
                _this.$q = $q;
                _this.$sce = $sce;
                _this.authenticationService = authenticationService;
                _this.httpService = httpService;
                _this.appSettings = appSettings;
                _this.organizationList = organizationList;
                _this.apiUrl = _this.appSettings.urls.apiUrl + "/reporting";
                _this.apiMetaUrl = _this.apiUrl + "/metadata";
                _this.authData = _this.authenticationService.authorizationData;
                return _this;
            }
            ApplicationApiService.prototype.getAssignedReports = function () {
                if (!ap.Utilities.isNullOrUndefined(this.authData.UserCacheKey) &&
                    this.authData.UserCacheKey !== Guid.empty) {
                    return this.get(this.apiMetaUrl + "/reports/all/" + this.authData.UserCacheKey);
                }
                else if (!ap.Utilities.isNullOrUndefined(this.authData.LoginSystem) &&
                    this.authData.LoginSystem === 'WP') {
                    // MP1 Users have an empty GUID for a User Cache Key so we get to fake the meta data return on this call
                    return this.$q(function (resolve) {
                        var dummyWPreturn = [
                            { name: 'Enterprise Reports', roleId: AutoPointRole.EnterpriseReportsUser, reports: [] },
                            { name: 'Dealer Reports', roleId: AutoPointRole.DealerReportsUser, reports: [] },
                            { name: 'User Reports', roleId: AutoPointRole.UserReportsUser, reports: [] },
                            { name: 'Internal Reports', roleId: AutoPointRole.InternalReportsUser, reports: [] }
                        ];
                        resolve(dummyWPreturn);
                    });
                }
            };
            ApplicationApiService.prototype.getReportMetadataAndParameters = function (metaDataId) {
                return this.get(this.apiMetaUrl + "/" + metaDataId);
            };
            ApplicationApiService.prototype.getOrganizationList = function (orgUnitCacheKey) {
                return this.get(this.apiUrl + "/" + orgUnitCacheKey + "/hierarchytree", null, 'organizationList', true);
            };
            ApplicationApiService.prototype.getAlphaOrg = function (orgUnitCacheKey) {
                return this.get(this.apiUrl + "/org/" + orgUnitCacheKey + "/GetAlphaOrg", null);
            };
            ApplicationApiService.prototype.getListOfAssignedHierarchies = function (userCacheKey) {
                return this.get(this.apiUrl + "/org/hierarchy/GetAssignedHierarchiesByUser/" + userCacheKey, null);
            };
            ApplicationApiService.prototype.getListOfHierarchyOrgs = function (hierarchyCacheKey) {
                return this.get(this.apiUrl + "/org/hierarchy/GetOrgsByHierarchy/" + hierarchyCacheKey, null);
            };
            ApplicationApiService.prototype.getListOfHierarchiesByOrg = function (orgCacheKey) {
                return this.get(this.apiUrl + "/org/hierarchy/GetHierarchiesByOrg/" + orgCacheKey, null);
            };
            ApplicationApiService.prototype.getServiceAdvisors = function (orgUnitCacheKey) {
                return this.get(this.apiUrl + "/org/" + orgUnitCacheKey + "/advisors", null);
            };
            ApplicationApiService.prototype.getReport = function (activeReport, reportPath) {
                var _this = this;
                var convertedPath = encodeURIComponent(activeReport.ssrsPath);
                return this.processParams(activeReport).then(function (convertedParameters) {
                    var method = 'render';
                    if (!ap.Utilities.isNullOrUndefined(activeReport.format)) {
                        method = 'download';
                    }
                    return _this.apiUrl + "/ssrs/" + method + "?report=%2f" + convertedPath + "%2f" + activeReport.ssrsName + convertedParameters;
                });
            };
            ApplicationApiService.prototype.getUserPermissions = function () {
                return this.get(this.apiMetaUrl + "/permission/" + this.authData.UserCacheKey);
            };
            ApplicationApiService.prototype.getWelcomepointReport = function (reportParameters, apiPath) {
                apiPath = apiPath.replace('-', '');
                return this.create(this.apiUrl + "/" + apiPath, reportParameters);
            };
            ApplicationApiService.prototype.processParams = function (activeReport) {
                return this.$q(function (resolve) {
                    var returnParams = '';
                    angular.forEach(activeReport.parameters, function (parameter) {
                        if (!ap.Utilities.isNullOrUndefined(parameter.value) &&
                            parameter.isActive &&
                            parameter.reportDataTypeId !== MetaParameters.DateRangeStyleStartEnd) {
                            switch (parameter.reportDataTypeId) {
                                case MetaParameters.MultiCheckbox:
                                    angular.forEach(parameter.value, function (value) {
                                        returnParams += '&' + parameter.name + '=' + value;
                                    });
                                    break;
                                case MetaParameters.DateRangeStyle1:
                                case MetaParameters.DateRangeStyle2:
                                    // User-defined param handling
                                    returnParams += "&" + parameter.name + "=" + parameter.value;
                                    if (parameter.value === ap.Constants.metaValues.date.custom.value &&
                                        !ap.Utilities.isNullOrUndefined(parameter.startDate) &&
                                        !ap.Utilities.isNullOrUndefined(parameter.endDate)) {
                                        returnParams +=
                                            '&ui_begin_date=' + parameter.startDate + '&ui_end_date=' + parameter.endDate;
                                    }
                                    break;
                                default:
                                    returnParams += "&" + parameter.name + "=" + parameter.value;
                                    break;
                            }
                        }
                    });
                    if (activeReport.format) {
                        returnParams += "&rs:format=" + activeReport.format;
                    }
                    if (ap.Utilities.isNullOrUndefined(activeReport.format)) {
                        returnParams += "&rs:Command=Render&rc:Toolbar=false";
                    }
                    resolve(returnParams);
                });
            };
            ApplicationApiService.$inject = ['$q', '$sce', 'authenticationService', 'httpService', 'appSettings'];
            return ApplicationApiService;
        }(Services.BaseHttpService));
        Services.ApplicationApiService = ApplicationApiService;
        angular.module('app.Services').service('applicationApiService', ApplicationApiService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
